export default class User {

    constructor(user) {
        try {
            if (user) {
                this.set(user);
                this.uid = user.uid ? user.uid : null;
                this.displayName = user.displayName;
                this.photoURL = user.photoURL;
                this.email = user.email;
            } else {
                const authUser = JSON.parse(localStorage.getItem('authUser'));
                if (authUser) {
                    this.set(authUser.user);
                }
            }
        } catch (error) {
            console.error("Error in User.constructor ", error);
            this.set(user);
            this.uid = null;
            this.displayName = 'untitled';
            this.photoURL = null;
            this.email = null;
        }
    }

    set(data) {
        Object.assign(this, data);
    }

    toJson() {
        return {
            uid: this.uid,
            displayName: this.displayName,
            photoURL: this.photoURL,
            email: this.email
        }
    }

}